import PointModule from '../Layer/PointModule';
import OlCore from '../OlCore';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import Select from 'ol/interaction/Select.js';
import { transWgsTo5186 } from '../projection';
import { click, singleClick } from 'ol/events/condition';
import Style from 'ol/style/Style';
import { Circle, Fill } from 'ol/style.js';
import { Simulate } from 'react-dom/test-utils';
import select = Simulate.select;
import { getImage } from '../Style/PointStyle';

class ObjectPhoto extends PointModule {
  private PhotoLayer: VectorLayer<VectorSource>;
  private photoSource!: VectorSource;
  private photoFeatures: Feature[] = [];
  private clickEvent: Select = new Select();
  constructor(core: OlCore) {
    super(core);
    // 지적도근점 레이어
    this.PhotoLayer = new VectorLayer<VectorSource>({
      properties: {
        id: 'PhotoLayer',
      },
      visible: true,
      zIndex: 10,
      style: () => {
        return new Style({
          image: getImage('photo', false),
        });
      },
      // minZoom: 16.5,
      // maxZoom: Infinity,
    });

    this.setLayers([this.PhotoLayer]);
  }

  public draw(datas) {
    this.photoFeatures = [];
    const features: any = [];
    datas.map((i) => {
      features.push(
        new Feature({
          geometry: new Point(transWgsTo5186([i.lon, i.lat])),
          properties: i,
        }),
      );
    });
    this.photoFeatures = features;
    this.photoSource = this.createSource(this.photoFeatures);
    this.PhotoLayer.setSource(this.photoSource);
    this.core.getMapInstance().getView().fit(this.photoSource.getExtent(), { duration: 500, maxZoom: 20 });
  }

  public onClickFeature(state, setState, setHide) {
    this.core.mapInstance.removeInteraction(this.clickEvent);
    this.clickEvent = new Select({
      layers: [this.PhotoLayer],
      condition: click,
      style: (e) => {
        return new Style({
          image: getImage('photo', true),
        });
      },
    });
    this.clickEvent.on('select', (e) => {
      const newArr = [...state];
      const targetCollection = e.target.getFeatures().getArray();

      if (targetCollection.length) {
        newArr.map((i) => {
          i.checked = targetCollection.filter((feature) => feature.getProperties().properties.fileName === i.fileName).length;
        });
        setHide(false);
        setState(newArr);
        document.getElementById('imageList')!.scrollTo({
          top: (document.getElementById(targetCollection[0].getProperties().properties.fileName) as any).offsetTop - 60,
          behavior: 'smooth',
        });
      } else {
        newArr.map((i) => {
          i.checked = false;
        });
        setState(newArr);
      }
    });
    this.core.mapInstance.addInteraction(this.clickEvent);
  }
  public onClickRow(row, isFit) {
    this.clickEvent.getFeatures().clear();
    const rowFeature = this.photoFeatures.find((feature) => feature.getProperties().properties.dronId === row.dronId);
    this.clickEvent.getFeatures().push(rowFeature!);
    if (isFit) {
      this.core.mapInstance.getView().fit((rowFeature!.getGeometry() as any).getExtent(), { duration: 500, maxZoom: 16 });
    }
  }

  public onCheck(row) {
    const thisRow: any = this.photoSource.getFeatures().find((feature) => feature.getProperties().properties.fileName === row.fileName);
    this.clickEvent.getFeatures().clear();
    this.clickEvent.getFeatures().push(thisRow);
  }

  public destroy() {
    this.PhotoLayer.setSource(null);
  }
}
export default ObjectPhoto;
